/**
 * z_cart-main-wccg-related.js — Relaterede produkter på cart-siden
 * ========================================================================
 * Del af: z_cart-main-wccg pakken
 *
 * Filer i pakken:
 *   sections/z_cart-main-wccg.liquid     ← Cart-side UI + schema + RENDERER related server-side
 *   assets/z_cart-main-wccg.js           ← Quantity steppers + bin + countdown
 *   assets/z_cart-main-wccg-related.js   ← Filter + add-to-cart (denne fil) 
 *
 * Arkitektur (server-side first):
 *   - Liquid pre-renderer ALLE related-items direkte i DOM
 *   - Hvert item har data-attributter: vid, triggers, available, inv-mgmt, inv-policy, inv-qty
 *   - JS henter cart via /cart.js
 *   - Filtrerer (sætter display:none):
 *       • Trigger-mismatch (hvis data-triggers er sat, kræver ét match i cart)
 *       • Produkt allerede i cart
 *       • Udsolgt (med tracking + policy=deny + qty<=0)
 *   - Skjuler hele container hvis ingen items synlige
 *   - Add-to-cart via /cart/add.js → re-render cart via WCCG_CART_refresh()
 *
 * Robusthed:
 *   - Hvis JS fejler → items vises ALLIGEVEL (server-rendered fallback)
 *   - Hvis fetch /cart.js fejler → items vises (kan ikke filtrere uden cart-data)
 *   - Hvis container ikke findes → exit gracefully
 *
 * Changelog:
 *   006 — Auto-add ved stepper-interaktion (ingen add-knap):
 *         • Stepper default qty = 0
 *         • Klik + → +1 (debounced 600ms) → add til cart
 *         • Klik - → -1 (min 0)
 *         • Efter add: item filtreres ud (allerede i cart), stepper resettes
 *         • Visuel feedback under add (opacity)
 *   005 — Eksponerer window.WCCG_CART_related_refresh() så main-modulet
 *         kan re-trigge filtrering efter cart-section refresh.
 *   004 — Lokal stepper [- 1 +] pr. related-item (samme look som cart).
 *         Add-knap tilføjer med valgte qty til cart.
 *   003 — Server-side rendering: Liquid genererer al HTML. JS skjuler kun.
 *         Garanteret synlig hvis JS fejler. Bruger data-attributter
 *         til filtrering i stedet for window.WCCG_CART_related config.
 *   002 — TriggerIds-filter: produkter med triggerIds vises kun hvis ÉN
 *         af deres trigger-variant-IDs findes i cart. Tom array = altid vis.
 *   001 — Initial version. Filter cart-items + inventory + add-to-cart.
 *
 * Version: 1.0 | Build: 006 | Date: 2026-05-24
 */
(function() {
  'use strict';

  var W = window.WCCG_CART || {};
  var name = (W.name || 'z_cart-main-wccg') + ':related';

  function log(msg, data) {
    if (data !== undefined) console.log('[' + name + '] ' + msg, data);
    else console.log('[' + name + '] ' + msg);
  }

  function init() {
    var container = document.querySelector('[data-wccg-cart-related]');
    var list = document.querySelector('[data-wccg-cart-related-list]');

    if (!container || !list) {
      log('Container [data-wccg-cart-related] not found — exit');
      return;
    }

    log('module loaded — found container with ' + container.querySelectorAll('[data-wccg-rel-vid]').length + ' pre-rendered item(s)');

    bindAddToCart(container);
    filterByCart(container);
  }

  /* ── Filtrér items ud fra cart-state ── */
  function filterByCart(container) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var cartVariantIds = cart.items.map(function(i) { return String(i.variant_id); });
        log('Cart variant IDs:', cartVariantIds);

        var items = container.querySelectorAll('[data-wccg-rel-vid]');
        var visibleCount = 0;

        items.forEach(function(item) {
          var vid = item.dataset.wccgRelVid;
          var title = (item.querySelector('.wccg-cart__rel-title') || {}).textContent || vid;
          var triggers = (item.dataset.wccgRelTriggers || '').split(',')
            .map(function(s) { return s.trim(); })
            .filter(function(s) { return s.length > 0; });
          var available = item.dataset.wccgRelAvailable === 'true';
          var invMgmt = item.dataset.wccgRelInvMgmt;
          var invPolicy = item.dataset.wccgRelInvPolicy;
          var invQtyStr = item.dataset.wccgRelInvQty;
          var invQty = invQtyStr ? parseInt(invQtyStr, 10) : null;

          /* 1. Skjul hvis produktet allerede er i kurv */
          if (cartVariantIds.indexOf(String(vid)) !== -1) {
            log('  ' + title + ' — allerede i kurv, skjules');
            item.style.display = 'none';
            return;
          }

          /* 2. TriggerIds-filter: vis kun hvis ÉN trigger findes i cart */
          if (triggers.length > 0) {
            var matched = triggers.some(function(tid) {
              return cartVariantIds.indexOf(String(tid)) !== -1;
            });
            if (!matched) {
              log('  ' + title + ' — ingen trigger match (kræver: ' + triggers.join(',') + '), skjules');
              item.style.display = 'none';
              return;
            }
            log('  ' + title + ' — trigger match');
          }

          /* 3. Inventory check */
          if (invMgmt && invMgmt !== '' && invMgmt !== 'null' && invPolicy !== 'continue') {
            if (!available || (invQty !== null && !isNaN(invQty) && invQty <= 0)) {
              log('  ' + title + ' — UDSOLGT, skjules');
              item.style.display = 'none';
              return;
            }
          }

          /* OK — vis */
          item.style.display = '';
          visibleCount++;
        });

        /* Skjul hele container hvis ingen items synlige */
        if (visibleCount === 0) {
          container.style.display = 'none';
          log('Ingen relaterede produkter at vise — container skjult');
        } else {
          container.style.display = '';
          log(visibleCount + ' relateret(e) produkt(er) vist');
        }
      })
      .catch(function(err) {
        log('Cart fetch fejlede, items forbliver synlige (fallback):', err);
      });
  }

  /* ──────────────────────────────────────────────────────────────
     STEPPER med AUTO-ADD (debounced)
     • Plus  → +1 visuelt → 600ms debounce → /cart/add.js med qty
     • Minus → -1 (min 0) visuelt → 600ms debounce → /cart/add.js
                hvis qty > 0, ellers blot reset visuelt
     • Efter add: refreshCartSection() → item filtreres ud → stepper reset
     ────────────────────────────────────────────────────────────── */
  var addTimers = {};
  var ADD_DEBOUNCE_MS = 600;

  function scheduleAdd(itemEl) {
    var vid = itemEl.dataset.wccgRelVid;
    if (!vid) return;

    clearTimeout(addTimers[vid]);
    addTimers[vid] = setTimeout(function() {
      var valEl = itemEl.querySelector('[data-wccg-rel-val]');
      var qty = valEl ? (parseInt(valEl.textContent, 10) || 0) : 0;
      if (qty <= 0) return;

      itemEl.style.opacity = '0.55';
      itemEl.style.pointerEvents = 'none';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty }] })
      })
        .then(function(r) {
          if (!r.ok) throw new Error('Add failed: ' + r.status);
          return r.json();
        })
        .then(function() {
          log('Auto-tilføjet: variant ' + vid + ' × ' + qty);
          /* Reset stepper visuelt (item filtreres ud ved refresh fordi det nu er i cart) */
          if (valEl) valEl.textContent = '0';
          itemEl.style.opacity = '';
          itemEl.style.pointerEvents = '';
          if (window.WCCG_CART_refresh && typeof window.WCCG_CART_refresh === 'function') {
            window.WCCG_CART_refresh();
          }
        })
        .catch(function(err) {
          console.error('[' + name + '] Auto-add fejl:', err);
          itemEl.style.opacity = '';
          itemEl.style.pointerEvents = '';
        });
    }, ADD_DEBOUNCE_MS);
  }

  function bindAddToCart(container) {
    if (container.dataset.wccgRelBound === '1') return;
    container.dataset.wccgRelBound = '1';

    container.addEventListener('click', function(e) {
      /* Stepper PLUS → +1, schedule auto-add */
      var plusBtn = e.target.closest('[data-wccg-rel-plus]');
      if (plusBtn) {
        e.preventDefault();
        var itemP = plusBtn.closest('[data-wccg-rel-vid]');
        var valElP = itemP ? itemP.querySelector('[data-wccg-rel-val]') : null;
        if (valElP) {
          var vP = (parseInt(valElP.textContent, 10) || 0) + 1;
          valElP.textContent = Math.min(99, vP);
          scheduleAdd(itemP);
        }
        return;
      }
      /* Stepper MINUS → -1 (min 0), schedule auto-add hvis qty > 0 */
      var minusBtn = e.target.closest('[data-wccg-rel-minus]');
      if (minusBtn) {
        e.preventDefault();
        var itemM = minusBtn.closest('[data-wccg-rel-vid]');
        var valElM = itemM ? itemM.querySelector('[data-wccg-rel-val]') : null;
        if (valElM) {
          var vM = (parseInt(valElM.textContent, 10) || 0) - 1;
          valElM.textContent = Math.max(0, vM);
          var vidM = itemM.dataset.wccgRelVid;
          if (parseInt(valElM.textContent, 10) > 0) {
            scheduleAdd(itemM);
          } else {
            /* Annullér pending add hvis ned til 0 */
            clearTimeout(addTimers[vidM]);
          }
        }
        return;
      }
    });
  }

  /* ── Public API: kaldes af z_cart-main-wccg.js efter refreshCartSection() ── */
  window.WCCG_CART_related_refresh = function() {
    var container = document.querySelector('[data-wccg-cart-related]');
    if (container) {
      container.dataset.wccgRelBound = ''; /* Force rebind */
      bindAddToCart(container);
      filterByCart(container);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
